<script lang="ts">
 import { onMount } from "svelte"
 import DeleteIcon from "./icons/DeleteIcon.svelte"
 import { letters, winEnLayoutLookup } from "./alphabet.ts"
 import { game } from "./game.ts"
 import { LetterClue } from "./match.ts";

 $: locked = !$game.query_isPlaying();

 function onKeyClick() {
     let letter = this.textContent.trim();
     $game.cmd_push(letter);
 }

 function onKeyUp(e) {
     let key = e.key;

     if (locked) {
         if (key === "Enter") {
             $game.cmd_reset()
         }

         return;
     }

     if (key.length > 1) {
         switch (key) {
             case "Backspace": $game.cmd_backspace(); break;
             case "Enter": $game.cmd_commit(); break;
         }
         return
     }

     key = key.toLowerCase()

     if (key in winEnLayoutLookup) {
         key = winEnLayoutLookup[key]
     }

     $game.cmd_push(key)
 }

 const clueClasses = {
     [LetterClue.Unknown]: "unknown",
     [LetterClue.NotHere]: "not-here",
     [LetterClue.Present]: "present",
     [LetterClue.Exact]: "exact",
 };

 function getKeyboardClueClass(idx, keyboardClues) {
     let baseClass = "letter ";
     let clueClass = clueClasses[keyboardClues[idx]];
     return baseClass + clueClass;
 }

 onMount(() => {
     window.addEventListener("keyup", onKeyUp);
     return () => {
         window.removeEventListener("keyup", onKeyUp);
     };
 })
</script>

<div class="wrapper">
    <div class="keyboard">
        <button disabled={locked} class="backspace" title="удалить" on:click={$game.cmd_backspace()}><DeleteIcon /></button>
        {#each letters as l, i}
            <button data-letter={l} disabled={locked} class={getKeyboardClueClass(i, $game.keyboardClues)} on:click={onKeyClick}>{l}</button>
        {/each}
        <button disabled={locked} class="enter" on:click={$game.cmd_commit()}>ВВОД</button>
    </div>
</div>

<style>
 .wrapper {
     align-self: stretch;
     flex-shrink: 1;
 }

 .keyboard {
     display: grid;
     grid-template-columns: repeat(24, 1fr);
     gap: 2px;
 }

 .keyboard button {
     touch-action: manipulation;
     user-select: none;
     text-align: center;
     cursor: pointer;
     display: block;
     padding: 0 4px;
     white-space: pre-wrap;
     min-height: 3em;
     border: 1px solid #555;
     background: transparent;
     transform: translateX(0);
     margin: 0;
     color: inherit;
     text-transform: uppercase;
 }

 @media screen and (min-width: 260px) {
     .keyboard button {
         border-bottom-width: 2px;
         border-right-width: 2px;
     }
 }

 .keyboard button:hover {
     border-color: #333;
 }

 .keyboard button:active {
     transform: translate(0px, 1px);
     border-bottom-width: 1px;
 }

 .backspace {
     grid-row: 3 / 4;
     grid-column: 1 / 4;
     text-align: left;
 }

 .backspace :global(.feather) { vertical-align: -5px; }

 .enter {
     grid-column: 22 / 25;
     font-size: .825em;
     line-height: 1rem;
 }

 .letter {
     grid-column: span 2;
 }

 .letter[data-letter="й"] {
     grid-column: 1 / 3;
 }

 .letter[data-letter="ф"] {
     grid-column: 2 / 4;
 }

 .letter[data-letter="я"] {
     grid-column:  4 / 6;
 }

 .letter.unknown {
     border-color: black;
     background: transparent;
 }
 .letter.present {
     border-color: orange;
     background: orange;
 }
 .letter.exact {
     color: #fff;
     background: green;
     border-color: green;
 }
 .letter.not-here, .letter.not-here:disabled {
     color: #fff;
     background: #3f3f3f;
 }

</style>
